import { useQueryClient } from "@tanstack/react-query";
import { useLocation, useNavigate } from "react-router-dom";
import { filtersIdMap } from "../../filter/utils";
import { createStylesheet } from "../../_app/utils/styles";
import { UIButton } from "../../_app/components";

interface Props {
  price: string;
  link: string[];
  tableType?: string;
  setTableType?: Function;
  setApplied: Function;
}

export const TotalToButton = ({ price, link, tableType, setTableType, setApplied }: Props) => {
  const classes = useStyles();
  const location = useLocation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const queryParams = new URLSearchParams(location.search);
  if (!price) {
    return <></>;
  }

  const resetFilter = () => {
    const params: string[] = [];
    queryParams.forEach((value, key) => {
      // TODO: preffix check?
      params.push(key);
    });
    params.forEach((key) => {
      if (key !== filtersIdMap.BILL_PERIOD) {
        queryParams.delete(key);
      }
    });

    switch (tableType) {
      case "CLI":
        queryParams.append(filtersIdMap.CLI, link?.[0]);
        break;
      case "ACCOUNT":
        queryParams.append(filtersIdMap.ACCOUNT, link?.[0]);
        break;
      case "COST_CENTRE":
        queryParams.append(filtersIdMap.COST_CENTRE, link?.[1]);
        break;
    }
    navigate({ search: queryParams.toString() }, { replace: true });
  };

  const applyTotalFilters = async () => {
    resetFilter();
    if (setTableType) setTableType("ALL");
    setApplied(true);
    queryClient?.resetQueries({ queryKey: ["usageAnalysis"] });
  };

  return (
    <UIButton
      data-cy="summary-total-button"
      size="small"
      variant="text"
      color="primary"
      className={classes.button}
      onClick={applyTotalFilters}
    >
      {price + ""}
    </UIButton>
  );
};

const useStyles = createStylesheet((theme) => ({
  button: {
    marginRight: "-12px",
    marginLeft: "-12px",
  },
}));
